const MAX_UNITS = 18446744073709551615n;
/** Crypto amounts stay in their asset's native scale, never in fiat minor units. */
export function parseExchangeAmount(value, decimals) {
    const units = parseExchangeBalance(value, decimals);
    if (BigInt(units) > MAX_UNITS)
        throw new Error('Exchange amount exceeds supported range');
    return units;
}
/** Available funds are not limited to the range of a single withdrawal. */
export function parseExchangeBalance(value, decimals) {
    assertDecimals(decimals);
    if (value.length > 100)
        throw new Error('Exchange balance exceeds supported precision');
    const match = /^(0|[1-9]\d*)(?:\.(\d+))?$/.exec(value);
    if (!match)
        throw new Error('Invalid exchange amount');
    const whole = match[1];
    const fraction = (match[2] ?? '').replace(/0+$/, '');
    if (whole === undefined || fraction.length > decimals)
        throw new Error('Unsupported exchange precision');
    const units = BigInt(`${whole}${fraction.padEnd(decimals, '0')}`);
    if (units.toString().length > 100)
        throw new Error('Exchange balance exceeds supported precision');
    return units.toString();
}
export function exchangeAmountDecimal(units, decimals) {
    assertDecimals(decimals);
    if (!/^(0|[1-9]\d{0,99})$/.test(units))
        throw new Error('Invalid exchange units');
    if (decimals === 0)
        return units;
    const padded = units.padStart(decimals + 1, '0');
    const fraction = padded.slice(-decimals).replace(/0+$/, '');
    const whole = padded.slice(0, -decimals);
    return fraction ? `${whole}.${fraction}` : whole;
}
export function validateExchangeAmount(input) {
    try {
        for (const units of [input.units, input.balanceUnits, input.minimumUnits])
            exchangeAmountDecimal(units, input.decimals);
        if (BigInt(input.units) > MAX_UNITS || BigInt(input.minimumUnits) > MAX_UNITS)
            return 'invalid';
    }
    catch {
        return 'invalid';
    }
    const units = BigInt(input.units);
    if (units === 0n)
        return 'invalid';
    if (units > BigInt(input.balanceUnits))
        return 'insufficient_balance';
    if (units < BigInt(input.minimumUnits))
        return 'below_minimum';
    return null;
}
function assertDecimals(decimals) {
    if (!Number.isInteger(decimals) || decimals < 0 || decimals > 18)
        throw new Error('Unsupported exchange decimals');
}
